// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Pi-c","resendInfoText":"OnGoingPaymentBox_resendInfoText__1rxO9"};